import { FC, useMemo } from 'react';
import { QLog } from '@qwealth/qdata';
import { TextInput } from '@qwealth/qcore';
import { isEmpty } from 'lodash';

interface Props {
  resource: Partial<QLog>;
}

const LinkedHousehold: FC<Props> = ({ resource }): JSX.Element => {
  const { owners, householdType, householdName } = resource;

  const link = useMemo(() => {
    let href = '';
    if (householdName && !isEmpty(owners) && householdType) {
      const householdQID = owners?.[0];
      const pathname = householdType === 'Regular' ? '/household' : `/prospect-households/${householdQID}`;
      const search = householdType === 'Regular' ? `household=${householdQID}` : 'householdTab=Profile';
      href = `${pathname}?${search}`;
    }
    return href;
  }, [owners, householdType, householdName]);

  return link ? <a href={link}>{householdName}</a> : <TextInput disabled value={householdName || 'N/A'} />;
};

export default LinkedHousehold;
